import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../lib/api';
import { useAsync } from '../lib/useAsync';
import { PageHeader } from '../components/Layout';
import { Card, StageBadge, Spinner, ErrorNote, Empty } from '../components/ui';
import { initials } from '../lib/format';
import { PIPELINE_ORDER, STAGE_LABELS, stageLabel } from '../lib/stages';
import { roofTypeLabel } from '../lib/roofTypes';

export default function Pipeline() {
  const [params, setParams] = useSearchParams();
  const stage = params.get('stage') || '';

  const { data: projects, error, loading, reload } = useAsync(
    () => api.get('/projects' + (stage ? `?stage=${stage}` : '')),
    [stage],
  );

  const setStage = (s) => setParams(s ? { stage: s } : {}, { replace: true });

  return (
    <>
      <PageHeader
        title="Pipeline"
        sub={stage ? stageLabel(stage) : projects ? `${projects.length} active projects` : ''}
        action={<Link className="act" to="/lead/new">＋ New</Link>}
      />
      <div className="view">
        <div className="seg" role="group" aria-label="Filter by stage">
          <button aria-pressed={!stage} onClick={() => setStage('')}>All</button>
          {PIPELINE_ORDER.map(s => (
            <button key={s} aria-pressed={stage === s} onClick={() => setStage(s)}>
              {STAGE_LABELS[s]}
            </button>
          ))}
        </div>

        {loading ? <Spinner label="Loading projects" /> : null}
        {error ? <ErrorNote onRetry={reload}>{error}</ErrorNote> : null}

        {projects ? (
          <Card tight>
            {projects.length ? projects.map(p => (
              <Link key={p.id} className="listrow" to={`/project/${p.id}`}>
                <span className="ava" aria-hidden="true">{initials(p.customer?.name || '?')}</span>
                <span className="nm">
                  {p.customer?.name || 'Unknown'}
                  <span className="sb" style={{ display: 'block', fontWeight: 400 }}>
                    {p.title} · {roofTypeLabel(p.roofType)} · {p.number}
                  </span>
                </span>
                <StageBadge stage={p.stage} />
              </Link>
            )) : <Empty>No projects in this stage.</Empty>}
          </Card>
        ) : null}
      </div>
    </>
  );
}
